/** Single hand 21 landmarks, normalized image coords x,y ∈ [0,1] */
export type Landmark = { x: number; y: number; z: number }
export type HandLandmarks = Landmark[]

export interface GestureFeatures {
  palmX: number
  palmY: number
  openness: number
  bothRaised: boolean
  pushPull: number
  confidence: number
  handedness: 'Left' | 'Right' | 'None'
}

export interface FeatureExtractConfig {
  primaryHandPolicy: 'dominant' | 'average' | 'firstDetected'
  raiseY: number
  fistOpenness: number
  openOpenness: number
  pushPullGain: number
  mirrorX: boolean
}

export interface GestureMappingConfig {
  deadzoneX: number
  maxSpeed: number
  fistOpenness: number
  openOpenness: number
  releaseDecay: number
  raisePause: boolean
}

export const DEFAULT_FEATURE_CFG: FeatureExtractConfig = {
  primaryHandPolicy: 'dominant',
  raiseY: 0.35,
  fistOpenness: 0.25,
  openOpenness: 0.75,
  pushPullGain: 1.0,
  mirrorX: true,
}

export const DEFAULT_MAPPING_CFG: GestureMappingConfig = {
  deadzoneX: 0.08,
  maxSpeed: 0.28,
  fistOpenness: 0.25,
  openOpenness: 0.75,
  releaseDecay: 4,
  raisePause: true,
}

export const PALM_INDICES = [0, 5, 9, 13, 17] as const
export const TIP_INDICES = [4, 8, 12, 16, 20] as const
